// Bundle page, logged in: in "Included Products" (modules/bundle-pricing/templates/bundle-products.php)
// a plug-in the customer already owns shows a link to My Deals instead of Try and its price line, and the hero
// (Son_Product_Highlight_Box) states how many of the bundle's plug-ins they own.
// Ownership comes from the answer personal-price.js announces; the cached page has none.

function renderOwnedLine(line, owned) {
    const items = line.dataset.sonBundleItems.split(',').map(Number);
    const count = items.filter((id) => owned.includes(id)).length;

    line.hidden = count === 0;
    line.querySelector('li').textContent = count === items.length
        ? line.dataset.textAll
        : line.dataset.textSome.replace('%1$d', count).replace('%2$d', items.length);
}

document.addEventListener('son-personal-price', (event) => {
    const owned = (event.detail.owned || []).map(Number);

    document.querySelectorAll('[data-son-bundle-owned-line]').forEach((line) => renderOwnedLine(line, owned));

    document.querySelectorAll('[data-son-bundle-item]').forEach((item) => {
        const note = item.querySelector('[data-son-bundle-owned]');
        if (!note) {
            return;
        }

        const isOwned = owned.includes(Number(item.dataset.sonBundleItem));
        note.hidden = !isOwned;
        item.querySelectorAll('.son-bundle-products__try, .son-bundle-products__saving').forEach((node) => {
            node.hidden = isOwned;
        });
    });
});
